exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clima-total-tag{display:inline-flex;align-items:center;justify-content:center;min-width:56px;padding:2px 8px;border-radius:10px;font-size:.78rem;font-weight:600;color:rgba(65,64,64,.91);line-height:1.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66ea2214","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/climan/components/cellComparison.vue
// module id = 1389
// module chunks = 2